import { phMoneyProps } from '~shared/constants/ph-money-props';
import { plural } from '~shared/lib/plural';

import { Col } from '@breeze-platform-ui/layout';
import Money from '@breeze-platform-ui/money';

import { calculateGracePeriod } from './grace-period';
import { calculateMonthlyPayment } from './loan-math';

import type { ProductParams } from '../product';
import { GracePeriodBadge } from '../ui/grace-period-badge/grace-period-badge';

const loanMoneyProps = { ...phMoneyProps, precision: 2 };

export function getInstallmentPeriodOptions(
  totalPrice: number,
  hasGracePeriod: boolean,
  {
    interestRate,
    originationFeeRate,
    originationFeeFlat,
    termsInMonths,
  }: ProductParams,
  loanAmount: number
) {
  return termsInMonths.map((term) => {
    const monthlyPayment = calculateMonthlyPayment(
      loanAmount,
      +term,
      interestRate,
      originationFeeRate,
      originationFeeFlat
    );
    const gracePeriodInMonths = hasGracePeriod
      ? calculateGracePeriod(totalPrice, term)
      : undefined;

    return {
      value: `${term}`,
      children: (
        <div className="flex w-full items-center justify-between">
          <Col alignCross="stretch" grow={1}>
            <p className="text-primary text-base font-bold">
              <Money {...loanMoneyProps} value={monthlyPayment} />
            </p>
            <p className="text-primary text-sm">
              x {term} {plural(term, 'month', 'months')}
            </p>
          </Col>
          {gracePeriodInMonths && (
            <GracePeriodBadge gracePeriodInMonths={gracePeriodInMonths} />
          )}
        </div>
      ),
    };
  });
}
